import { render } from "./Podcast.vue?vue&type=template&id=783bc2b0&scoped=true"
const script = {}

import "./Podcast.vue?vue&type=style&index=0&id=783bc2b0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783bc2b0"]])

export default __exports__